import api from '../../services/api';

/*
 * The locations of a warehouse, and their upkeep.
 *
 * Two scopes the server keeps apart:
 *   reading  anybody who reaches the warehouse
 *   writing  only the **holder** of the space — the operator in its centre, a
 *            company in its own warehouse. Whoever only has a contract there
 *            can operate, not redesign somebody else's rack.
 */

/**
 * Not paginated: answers every location that matches, as `{ slots, count }`.
 *
 * Each one carries `occupancy` and `usage_pct`, worked out from the kardex
 * rather than stored, and `can_delete`.
 *
 * @param {object} params - `warehouse, zone_type, search, is_active ('1'|'0')`.
 */
export const getSlotsRequest = async (params) => {
  return await api.get('slots/', { params });
};

/**
 * @param {object} payload - `warehouse_id` plus `name, code, zone_type,
 *   pick_rank, capacity, is_active`.
 */
export const createSlotRequest = async (payload) => {
  return await api.post('slots/create/', payload);
};

/**
 * A sheet of locations into one warehouse. All or nothing: a 400 carries
 * `error` and, when the rows are the problem, `errors` as `[{row, message}]`
 * with the Excel row numbers.
 *
 * @param {FormData} formData - `excel_file` and `warehouse_id`.
 */
export const uploadSlotsRequest = async (formData) => {
  return await api.post('slots/bulk/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** Only the fields sent are written, and the answer is the whole location. */
export const updateSlotRequest = async (slotId, payload) => {
  return await api.patch(`slots/${slotId}/`, payload);
};

/** Refused while the location has stock or any history in the kardex. */
export const deleteSlotRequest = async (slotId) => {
  return await api.delete(`slots/${slotId}/delete/`);
};
